module.exports = __webpack_public_path__ + "static/media/female-active.ffe192e7.svg";